export default __webpack_public_path__ + "static/illustration-action.url-a9992e0b9935250d931aafee24ed410c.svg";